module.exports = __webpack_public_path__ + "static/media/result-page-min.c83c54dc.png";